import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'automata-notifications-settings-link',
  templateUrl: './notification-settings-link.component.html',
  styleUrls: ['./notification-settings-link.component.scss'],
  imports: [CommonModule, TranslateModule, MatIconModule],
})
export class NotificationSettingsLinkComponent {
  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
  ) {}

  openNotificationSettings(): void {
    // note the overlay for the notification setting page requires a refresh of the page to appear
    // opening in a new tab to avoid any unsaved changes in the side panel
    window.open(
      this.router.serializeUrl(
        this.router.createUrlTree(['./'], {
          relativeTo: this.route,
          queryParams: { open_notification_settings: true },
        }),
      ),
      '_blank',
    );
  }
}
